export enum SearchActionType {
  SET_QUERY = 'SET_QUERY',
  SET_UPDATE_QUERY = 'SET_UPDATE_QUERY',
  SET_DATA = 'SET_DATA',
  SET_VISUAL = 'SET_VISUAL',
  SET_ARE_WIDGETS_LOADING = 'SET_ARE_WIDGETS_LOADING',
  RESET = 'RESET',
}
